import { Box, Grid, Skeleton, Stack } from "@mui/material";
import React from "react";

const cardSx = {
  borderRadius: "20px",
  border: "1px solid #E5EDF5",
  backgroundColor: "#FFFFFF",
  overflow: "hidden",
  boxShadow: "0 10px 30px rgba(31, 78, 121, .08)",
};

export function BidsGridSkeleton({ count = 6 }) {
  return (
    <Grid
      container
      spacing={{ xs: 2, sm: 2, lg: 3 }}
      columns={{ xs: 2, sm: 6, lg: 12 }}
      aria-label="טוען מכרזים"
      aria-busy="true"
      sx={{ width: "100%", m: 0 }}
    >
      {Array.from({ length: count }).map((_, index) => (
        <Grid
          item
          xs={2}
          sm={3}
          md={4}
          key={index}
          sx={{ display: "flex", width: "100%", minWidth: 0 }}
        >
          <Box sx={{ ...cardSx, width: "100%" }}>
            <Skeleton variant="rectangular" width="100%" height={210} animation="wave" />
            <Box sx={{ p: 2.25 }}>
              <Skeleton variant="text" width="68%" height={30} animation="wave" />
              <Skeleton variant="text" width="90%" height={22} animation="wave" />
              <Skeleton variant="text" width="48%" height={22} animation="wave" />
              <Stack direction="row" justifyContent="space-between" sx={{ mt: 2 }}>
                <Skeleton variant="rounded" width={86} height={34} animation="wave" />
                <Skeleton variant="rounded" width={104} height={34} animation="wave" />
              </Stack>
            </Box>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
}

export function ProfilePageSkeleton() {
  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      sx={{ width: "100%", maxWidth: 1180, mx: "auto", gap: { xs: 2, md: 3 } }}
      aria-label="טוען פרופיל"
      aria-busy="true"
    >
      <Box sx={{ ...cardSx, width: { xs: "100%", md: 260 }, p: 2 }}>
        <Skeleton variant="rounded" width="100%" height={52} animation="wave" />
        <Skeleton variant="rounded" width="100%" height={52} animation="wave" sx={{ mt: 1.25 }} />
        <Skeleton variant="rounded" width="100%" height={52} animation="wave" sx={{ mt: 1.25 }} />
      </Box>

      <Box sx={{ ...cardSx, flex: 1, width: "100%", p: { xs: 2, sm: 3, md: 4 } }}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Skeleton variant="circular" width={72} height={72} animation="wave" />
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width="36%" height={34} animation="wave" />
            <Skeleton variant="text" width="70%" height={22} animation="wave" />
            <Skeleton variant="text" width="48%" height={22} animation="wave" />
          </Box>
        </Stack>
        <Skeleton variant="rounded" width="100%" height={150} animation="wave" sx={{ mt: 3 }} />
        <Skeleton variant="rounded" width="100%" height={86} animation="wave" sx={{ mt: 2 }} />
      </Box>
    </Stack>
  );
}
